import type { SagaIterator } from 'redux-saga';
import { call, takeEvery } from 'redux-saga/effects';

import { resourceSagaUtils, resourceStoreTypes } from '../core';
import type { QcsSyncResourcesConfig, QcsSyncResourcesConfigProps } from '../core/resourceStoreTypes';
import * as actions from './accountsBalancesActions';
import { getLastSyncDate } from './accountsBalancesSelectors';
import { type AccountsBalanceProps, mkAccountsBalance } from './accountsBalancesTypes';

const mkAccountsBalancesConfig = resourceStoreTypes.createTypedQcsSyncResourcesConfigFactory<AccountsBalanceProps>();

const mkConfig = (
  props: Partial<QcsSyncResourcesConfigProps<AccountsBalanceProps>>,
): QcsSyncResourcesConfig<AccountsBalanceProps> =>
  mkAccountsBalancesConfig({
    resourceName: 'accounts balances',
    resourceBaseUrl: '/accounts/balances',
    getLastSyncDate,
    transformResponseToResources: (response) => response?.data?.resources?.map((data) => mkAccountsBalance(data)),
    ...props,
  });

export function* getAccountsBalancesActionWatcher(): SagaIterator {
  yield call(
    resourceSagaUtils.takeAndDebounce<[QcsSyncResourcesConfig<AccountsBalanceProps>]>,
    actions.getAccountsBalances.type,
    resourceSagaUtils.qcsSyncGetResources<AccountsBalanceProps>,
    mkConfig({
      successAction: actions.getAccountsBalancesSuccess,
      failureAction: actions.getAccountsBalancesFailure,
    }),
  );
}

export function* batchAccountsBalancesActionWatcher(): SagaIterator {
  yield takeEvery(
    actions.batchAccountsBalances.type,
    resourceSagaUtils.qcsSyncUpdateResources<AccountsBalanceProps>,
    mkConfig({
      successAction: actions.batchAccountsBalancesSuccess,
      failureAction: actions.batchAccountsBalancesFailure,
    }),
  );
}

export default [getAccountsBalancesActionWatcher, batchAccountsBalancesActionWatcher];
